import script from "./router-tabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./router-tabs.vue?vue&type=script&lang=ts&setup=true"

import "./router-tabs.vue?vue&type=style&index=0&id=50790eb6&lang=scss"

const __exports__ = script;

export default __exports__